import { render, staticRenderFns } from "./declaracaoBens.vue?vue&type=template&id=273da5d0&scoped=true&"
import script from "./declaracaoBens.vue?vue&type=script&lang=js&"
export * from "./declaracaoBens.vue?vue&type=script&lang=js&"
import style0 from "./declaracaoBens.vue?vue&type=style&index=0&id=273da5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273da5d0",
  null
  
)

export default component.exports